<template>
	<div class="scrollable only-y">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-account-settings-variant widget-icon accent-text fs-30"></i> {{ $t('menu.consumen') }}</h2>
		</div>
		<el-card>
			<el-tabs type="border-card" v-model="activeName">
				<el-tab-pane label="Index" name="index">
					<el-card>
						<div slot="header" class="clearfix">
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10" v-if="filter.btnStatus==2">
									Bussiness Account : <br>
									<span style="font-size:32px;">{{ (total) }}</span>
								</el-card>
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10" v-else>
									Personal Account : <br>
									<span style="font-size:32px;">{{ (total) }}</span>
								</el-card>
							</el-col>
						</div>
						<template>
							<span>
								<el-input
									class="search-customer mb-10 fl-l" style="width:auto;"
									prefix-icon="el-icon-search"
									placeholder="Search Customer"
									clearable
									@keypress.native="doSearchCustomer"
									@clear="doSearchCustomer"
									@keyup.native="doSearchCustomer"
									v-model="searchCustomer">
								</el-input>&nbsp;
								<el-select v-model="search_type" @change="doSearchCustomer">
									<el-option value="name" label="Name"/>
									<el-option value="waba_number" label="WABA Number"/>
								</el-select>
								<el-radio-group v-model="filter.btnStatus" class="fl-r mb-25" @change="loadConsumen()">
									<el-radio-button label="2" v-model="filter.btnStatus">{{custType.bussiness}}</el-radio-button>
									<el-radio-button label="1" v-model="filter.btnStatus">{{custType.personal}}</el-radio-button>
								</el-radio-group>
							</span>
							<el-pagination
								background
								prev-text="Prev"
								next-text="Next"
								layout="prev, pager, next"
								:page-size="10"
								@current-change="paginateConsumen"
								:current-page="currentPage"
								:total="parseInt(total)">
							</el-pagination>
							<el-table :data="consumen" class="v2-table.styled" style="width: 100%" v-loading="loadingConsumen" element-loading-text="Loading..."
								element-loading-spinner="el-icon-loading">
								<el-table-column prop="customer_name" label="Company Name" width="350" fixed="left">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ capitalizeFirstLetter(props.row.customer_name) }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="created_at" label="Created At" width="200">
									<template slot-scope="props">
										<p style="font-weight:bold;">{{ formatDate(props.row.created_at, "DD/MM/YY HH:mm:ss") }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="user" label="PIC Name" width="250">
									<template slot-scope="props">
										<p v-if="props.row.user.length == 0" style="font-weight:bold;">
											-
										</p>
										<p v-else style="font-weight:bold;">{{capitalizeFirstLetter(props.row.user[0].name)}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="user" label="PIC Email" width="300">
									<template slot-scope="props">
										<p v-if="props.row.user.length == 0" style="font-weight:bold;">
											-
										</p>
										<p v-else style="font-weight:bold;">{{ props.row.user[0].email }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="customer_type" label="Type" width="200">
									<template slot-scope="props">
										<el-tag v-if="props.row.customer_type == '2' && filter.btnStatus=='2'" type="success" >Business</el-tag>
										<p v-else-if="props.row.customer_type == '1' && filter.btnStatus=='1'" style="font-weight:bold;" type="default">Personal</p>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="#" width="">
									<template slot-scope="scope">
										<el-button @click="detailConsumen(scope.row.customer_id)" type="primary" size="small">
											<i class="mdi mdi-eye"></i> 
											<!-- Detail -->
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-card>
					<el-card class="mt-10">
						<el-pagination
							background
							prev-text="Prev"
							next-text="Next"
							layout="prev, pager, next"
							:page-size="10"
							@current-change="paginateConsumen"
							:current-page="currentPage"
							:total="parseInt(total)">
						</el-pagination>
					</el-card>
				</el-tab-pane>
				<el-tab-pane label="Information" name="information">
					<el-card>
						<div slot="header" class="clearfix">
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
									Registered WABA : <br>
									<span style="font-size:32px;">{{ (detailCount) }}</span>
								</el-card>
							</el-col>
						</div>
						<template>
							<span>
								<el-date-picker size="mini" class="mr-10" style="width: 275px;" v-model="selectedStartDate" :picker-options="pickerOptions" :unlink-panels="true" :editable="false" type="daterange" @change="doSearchDetail" range-separator="To" start-placeholder="Start date" end-placeholder="End date"/>
								<el-select size="mini" v-model="filter_type" @change="doSearchDetail" class="mr-10">
									<el-option value="all" label="All"/>
									<el-option value="completed" label="Completed"/>
									<el-option value="waba_id" label="WABA ID is NULL"/>
									<el-option value="pic" label="PIC is NULL"/>
								</el-select>
								<el-select size="mini" v-model="search_type_info" @change="doSearchDetail" class="mr-10">
									<el-option value="waba_id" label="WABA ID"/>
									<el-option value="waba_number" label="Phone Number"/>
									<el-option value="service_name" label="Service Name"/>
									<el-option value="name" label="Company Name"/>
									<el-option value="masking_name" label="Masking Name"/>
									<el-option value="pic" label="PIC Business"/>
								</el-select>
								<el-input size="mini"
									class="search-customer mb-10 fl-l" style="width:auto;"
									prefix-icon="el-icon-search"
									placeholder="Search"
									clearable
									@keypress.native="doSearchDetail"
									@clear="doSearchDetail"
									@keyup.native="doSearchDetail"
									v-model="searchDetail">
								</el-input>&nbsp;
							</span>
							<el-pagination
								background
								prev-text="Prev"
								next-text="Next"
								layout="prev, pager, next"
								:page-size="10"
								@current-change="paginateDetailInfo"
								:current-page="currentPage"
								:total="parseInt(detailCount)">
							</el-pagination>
							<el-table :data="detailInfo" class="v2-table.styled" style="width: 100%" v-loading="loadingDetailInfo" element-loading-text="Loading..."
								element-loading-spinner="el-icon-loading">
								<el-table-column prop="join_date" label="Join Date" width="200" fixed="left">
									<template slot-scope="props">
										<span v-if="props.row.join_date!=null">{{ formatDate(props.row.join_date, "DD-MM-YYYY HH:mm:ss") }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="waba_id" label="WABA ID" width="200">
									<template slot-scope="props">
										<span v-if="props.row.waba_id">{{ props.row.waba_id }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="phone_number" label="Phone Number" width="200">
									<template slot-scope="props">
										<span v-if="props.row.phone_number">{{ props.row.phone_number }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="service_name" label="Service Name" width="200">
									<template slot-scope="props">
										<span v-if="props.row.service_name">{{ props.row.service_name }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="company_name" label="Company Name" width="400">
									<template slot-scope="props">
										<span v-if="props.row.company_name">{{ props.row.company_name }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="masking_name" label="Masking Name" width="300">
									<template slot-scope="props">
										<span v-if="props.row.masking_name">{{ props.row.masking_name }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="pic_business" label="PIC Business" width="200">
									<template slot-scope="props">
										<span v-if="props.row.pic_business">{{ props.row.pic_business }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="notes" label="Notes" width="500">
									<template slot-scope="props">
										<span v-if="props.row.notes">{{ props.row.notes }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="phone_status" label="Phone Status" width="200">
									<template slot-scope="props">
										<span v-if="props.row.phone_status">{{ props.row.phone_status }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="bot_position" label="BOT Position" width="200">
									<template slot-scope="props">
										<span v-if="props.row.bot_position">{{ props.row.bot_position }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="helpdesk_position" label="Helpdesk Position" width="200">
									<template slot-scope="props">
										<span v-if="props.row.helpdesk_position">{{ props.row.helpdesk_position }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="connection" label="Connection" width="200">
									<template slot-scope="props">
										<span v-if="props.row.connection">{{ props.row.connection }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column prop="webhook" label="Webhook" width="1000">
									<template slot-scope="props">
										<span v-if="props.row.webhook">{{ props.row.webhook }}</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-card>
				</el-tab-pane>
				<el-tab-pane label="Product" name="product">
					<el-card>
						<div slot="header" class="clearfix">
							<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
								<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
									Registered Whatsapp Conversation Based on WABA ID/Consumen Id : <br>
									<span style="font-size:32px;">{{ detailCountProduct }}</span>
								</el-card>
							</el-col>
						</div>
						<template>
							<span>
								<el-select v-model="search_type_product" @change="doSearchProduct" class="mr-10">
									<el-option value="waba_number" label="Phone Number"/>
									<el-option value="customerId" label="Consumen ID"/>
									<el-option value="waba_id" label="WABA ID"/>
									<el-option value="product_type" label="Product Type"/>
									<el-option value="prefix" label="Prefix"/>
								</el-select>
								<el-input
									class="search-customer mb-10 fl-l" style="width:auto;"
									prefix-icon="el-icon-search"
									placeholder="Search Product"
									clearable
									@keypress.native="doSearchProduct"
									@clear="doSearchProduct"
									@keyup.native="doSearchProduct"
									v-model="searchProduct">
								</el-input>&nbsp;
							</span>
							<el-pagination
								background
								prev-text="Prev"
								next-text="Next"
								layout="prev, pager, next"
								:page-size="10"
								@current-change="paginateProduct"
								:current-page="currentPage"
								:total="parseInt(detailCountProduct)">
							</el-pagination>
							<el-table :data="detailProduct" class="v2-table.styled" style="width: 100%" v-loading="loadingAllService" element-loading-text="Loading..."
								element-loading-spinner="el-icon-loading">
								<el-table-column prop="bussinessId" label="WABA ID" width="200"></el-table-column>
								<el-table-column prop="customerId" label="CONSUMEN ID" width="200"></el-table-column>
								<el-table-column prop="number" label="Phone Number" width="200">
									<template slot-scope="props">
											<span>
												{{ props.row.numberService.number }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="type" label="Product Type" width="200">
									<template slot-scope="props">
										<div v-if="props.row.numberService" v-for="(i, k) in props.row.numberService.product" :key="k">
											{{ i.aliasName }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="monthlyFee" label="Monthly Fee" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.monthly_free_count ? "Rp "+tx.monthly_free_count : 0 }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="allowCBP" label="Allow CBP" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.disabled_quota_cbp == "no" ? "No" : "Yes" }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="prefix" label="Prefix" width="400">
									<template slot-scope="props">
										<!-- <div v-for="(tx, ky) in props.row.numberService.product" :key="ky"> -->
											<!-- <div v-if="prefixData"> -->
												<div v-for="(pr, kpr) in prefixData" :key="kpr" style="padding-right: 60px">
													<span>{{ pr }}</span>
												</div>
											<!-- </div> -->
											<!-- <span v-else>-</span> -->
										<!-- </div> -->
										<!-- <div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											<div v-if="tx.allowedPrefix">
												<div v-for="(pr, kpr) in tx.allowedPrefix" :key="kpr">
													<span>{{ pr }}</span>
												</div>
											</div>
											<span v-else>-</span>
										</div> -->
									</template>
								</el-table-column>
								<el-table-column prop="serviceFee" label="Service Fee" width="200" style="text-align: center;">
									<template slot-scope="props">
										<div v-for="(sv, ky) in props.row.numberService.product" :key="ky">
											<span v-if="sv.serviceType=='percentage'">
												{{ sv.serviceFee ? sv.serviceFee+" %" : 0 }}
											</span>
											<span v-else>
												{{ sv.serviceFee ? "Rp "+sv.serviceFee : 0 }}
											</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="tax" label="Tax" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.tax ? tx.tax+"%" : 0 }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="creditType" label="Credit Type" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.count ? "CBP" : "CBP" }}<br>
											{{ tx.count_bi ? "BI" : "BI" }}<br>
											{{ tx.count_ui ? "UI" : "UI" }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="internationalLimit" label="INT Limit" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.monthly_free_count_international ? tx.monthly_free_count_international : 0 }}<br>
											{{ tx.monthly_free_count_international_bi ? tx.monthly_free_count_international_bi : 0 }}<br>
											{{ tx.monthly_free_count_international_ui ? tx.monthly_free_count_international_ui : 0 }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnLimit" label="IDN Limit" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.monthly_free_count ? tx.monthly_free_count : 0 }}<br>
											{{ tx.is_bi_max == true ? 'MAX' : tx.monthly_free_count_bi }}<br>
											{{ tx.is_ui_max == true ? 'MAX' : tx.monthly_free_count_ui }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnTopup" label="IDN Topup" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.count ? tx.count : 0 }}<br>
											{{ tx.count_bi ? tx.count_bi : 0 }}<br>
											{{ tx.count_ui ? tx.count_ui : 0 }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnBundle" label="IDN Bundle" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											{{ tx.cbp_bundle ? tx.cbp_bundle : 0 }}<br>
											{{ tx.bi_bundle ? tx.bi_bundle : 0 }}<br>
											{{ tx.ui_bundle ? tx.ui_bundle : 0 }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnDiscount" label="IDN Discount" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											<div v-if="tx.prefix">
												<div v-for="(pref, kpref) in tx.prefix" :key="kpref">
													<div v-if="pref.code_prefix=='+62'">
														{{ pref.discount == false ? 0 : pref.discount.cbp.value }}<br>
														{{ pref.discount == false ? 0: pref.discount.bi.value }}<br>
														{{ pref.discount == false ? 0 : pref.discount.ui.value }}
													</div>
												</div>
											</div>
											<span v-else>0</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnPrice" label="IDN Price" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											<div v-if="tx.prefix">
												<div v-for="(pref, kpref) in tx.prefix" :key="kpref">
													<div v-if="pref.code_prefix=='+62'">
														{{ pref.price.cbp ? pref.price.cbp : 0 }}<br>
														{{ pref.price.bi ? pref.price.bi : 0 }}<br>
														{{ pref.price.ui ? pref.price.ui : 0 }}
													</div>
												</div>
											</div>
											<span v-else>{{ tx.price }}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="idnPriceWithTax" label="IDN Price (Inc Tax)" width="200">
									<template slot-scope="props">
										<div v-for="(tx, ky) in props.row.numberService.product" :key="ky">
											<div v-if="tx.prefix">
												<div v-for="(pref, kpref) in tx.prefix" :key="kpref">
													<div v-if="pref.code_prefix=='+62'">
														{{ pref.price.cbp ? pref.price.cbp+(pref.price.cbp*tx.tax/100) : 0 }}<br>
														{{ pref.price.bi ? pref.price.bi+(pref.price.bi*tx.tax/100) : 0 }}<br>
														{{ pref.price.ui ? pref.price.ui+(pref.price.ui*tx.tax/100) : 0 }}
													</div>
												</div>
											</div>
											<span v-else>{{ tx.price * 0/100 }}</span>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-card>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
const cityOptions = ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen'];

export default {
	name: 'Consumen',
	// props: {
    //     dateRange: {
    //         type: Array
    //     }
    // },
	data () {
		return {
			searchCustomer:this.$route.query.query || "",
			searchDetail:this.$route.query.query || "",
			searchProduct:this.$route.query.query || "",
			// selectedStartDate: [
            //     moment().subtract(1,"day").format("YYYY-MM-DD"),
            //     moment().format("YYYY-MM-DD")
            // ],
			selectedStartDate: "",
			// selectedStartDate: [
			// 	moment().format("YYYY-MM-DD"),
			// 	moment().format("YYYY-MM-DD")
			// ],
			searchStartDate: [
                moment().subtract(1,"day").hours(0).minutes(0).seconds(0).format(),
                moment().hours(0).minutes(0).seconds(0).format()
            ],
			total:'',
			consumen: [],
			checked: {},
			dp_user: [],
			cust_type: {
				personal: '1',
				bussiness: '2'
			},
			product:[],
			products: {
				allowedUser: "",
				productName: "",
				productSKU: "",
				description: "",
				createdAt: "",
				updatedAt: "",
				type: "",
				plan: "",
				price: "",
				minPrice: "",
				tax: "",
				count: "",
				aliasName: ""
			},
			filter:{
				btnStatus: '2'
			},
			total:'',
			loadingConsumen:true,
			currentPage: parseInt(this.$route.query.page) || 1,
			currentPageCustomer: 1,
			dialogTableVisible: false,
			dialogFormVisible: false,
			formLabelWidth: '200px',
			checkAll: false,
			checkedCities: ['Shanghai', 'Beijing'],
			cities: cityOptions,
			isIndeterminate: true,
			custType:{
				personal:'Personal',
				bussiness:'Bussiness'
			},
			timeout:null,
			filter_type: "all",
			search_type: "waba_number",
			search_type_info: "waba_id",
			search_type_product: "waba_number",
			activeName: 'index',
			listAllServices: [],
			loadingAllService: false,
			loadingDetailInfo: false,
			loadingDetailInfoProduct: false,
			listDetailInformation: [],
			totalService:0,
			totalInfo: 0,
			totalInfoProduct: 0,
			detailInfo: [],
			detailProduct: [],
			prefixData: {},
			detailProductVar: {
				businessId: "",
				customerId: "",
				phoneNumber: "",
				productType: "",
				monthlyFee: "",
				allowCBP: "",
				prefix: "",
				serviceFee: "",
				tax: "",
				creditType: "",
				internationalLimit: "",
				idnLimit: "",
				idnTopup: "",
				idnBundle: "",
				idnDiscount: "",
				idnPrice: "",
				idnPriceWithTax: ""
			},
			detailCount: 0,
			detailCountProduct: 0,
			pickerOptions: {
				disabledDate: time => {
					var today = moment(), diff = today.diff(moment(time), 'd')
					if(diff > 1440 || diff < 0){
						return true
					} else {
						if(diff == 0){
							if(today.isSame(moment(time), 'd') == false){
								return true
							} else {
								return false
							}
						}
						return false
					}
				}
			},
			// totalCount:100000
		}
	},
	methods: {
		// changeFilter() {
        //     // this.currentPage = 1
        //     this.searchStartDate = this.selectedStartDate.slice()
        //     // this.searchNumber = this.selectedPhone
        //     // this.searchField = this.selectedField
        //     // this.searchTerm = this.filterInput
		// 	// this.loadReport(this.currentPage, null, { search_by: this.searchField, search: this.searchTerm })
		// },
		showPrefix(val){
			// console.log("val",val)
		},
		doSearchCustomer(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.buildQueryParam("query", this.searchCustomer)
				this.loadConsumen()
			}, 1000)
			this.currentPage = 1
		},
		doSearchDetail(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.buildQueryParam("query", this.searchDetail)
				this.detailInfoData()
			}, 1000)
			this.currentPage = 1
		},
		doSearchProduct(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.buildQueryParam("query", this.searchProduct)
				this.detailInfoProduct()
			}, 1000)
			this.currentPage = 1
		},
		buildQueryParam(key = null, val = null){
			// let q = window.location.search.split("?")
			// q.shift()
			// console.log(q)
			// if(q.length < 1){
			// 	q = { [key]: val }
			// } else {
			// 	_.map(q[0].split("&"), (val, key) => {
			// 		let [k, v] = val.split("=")
			// 		q.push({ [k]: v })
			// 	})
			// }
			// console.log(q)
			// let query =_.map(q, (val, key) => {
			// 	return { key: key, value: val }
			// })
			// if(key != null) {
			// 	let index = _.findIndex(query, v => v.key == key)
			// 	if(index !== -1){
			// 		query[index] = { key: key, value: val }
			// 	} else {
			// 		query.push({ key: key, value: val })
			// 	}
			// }
			// query = query.filter(v => { return v.value != null && v.value != "" })
			// // this.$route.query[key] = val
			// window.history.replaceState(null, null, "?" + query.map((v, k) => { return v.key + "=" + v.value }).join("&"));
		},
	    async doGetSearchCustomer(query = "", page = 1){
	      this.loadingConsumen = true
	      await api({
	        method: 'get',
	        url:config.baseApi+'consumen',
	        params:{
	        	query: query,
				page: this.currentPage,
				customer_type: this.filter.btnStatus
	        }
	      }).then(result => {
	        this.consumen = result.data.data.consumen
	        // console.log(this.consumen);
	        // console.log('this consumen',this.consumen)
	        this.loadingConsumen = false
	      }).catch(error => {
	        console.error("Failed : " + error);
	        this.loadingConsumen = false
	      })
	    },
		customerFiltered() {
			return this.consumen.filter(({customer_name}) => (customer_name).toString().toLowerCase().indexOf(this.searchCustomer.toString().toLowerCase()) !== -1)
		},
		resetDateFilter() {
			this.$refs.filterTable.clearFilter('date');
		},
		clearFilter() {
			this.$refs.filterTable.clearFilter();
		},
		formatter(row, column) {
			return row.address;
		},
		filterTag(value, row) {
			return row.tag === value;
		},
		filterHandler(value, row, column) {
			const property = column['property'];
			return row[property] === value;
		},
		handleCheckAllChange(val) {
			this.checkedCities = val ? cityOptions : [];
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.cities.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		async loadService(){
			let custId = this.$route.params.consumen
			this.loadingService = true
			await api({
				method: "get",
				url: config.baseApi + "consumen/" + custId + "/services"
			}).then(resp => {
				if(resp.data.ec == 200) this.listServices = resp.data.data
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingService = false
		},
		async loadAllService(page = 1){
			this.loadingAllService = true
			await api({
				method: "get",
				url: config.baseApi + "customer/information",
				params: {
					page: page
				}
			}).then(resp => {
				// console.log("res all service all",resp)
				if(resp.data.ec == 200){
					this.listAllServices = resp.data.data.services
					this.totalService = resp.data.data.count	
				}
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingAllService = false
		},
		async loadDetailInfo(page = 1){
			this.loadingDetailInfo = true
			await api({
				method: "post",
				url: config.baseApi + "customer/detail_information?page="+page,
				// params: {
				// 	page: page
				// }
			}).then(resp => {
				// console.log("res all service",resp)
				if(resp.data.ec == 200){
					this.listDetailInformation = resp.data.data
					this.totalInfo = resp.data.data.length
				}
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingDetailInfo = false
		},
		async detailInfoData(page = 1){
			this.loadingDetailInfo = true
			await api({
				method: "get",
				url: config.baseApi + "detail-info-customer",
				params: {
					page,
					query: this.searchDetail,
					query_by: this.search_type_info,
					filter: this.filter_type,
					startDate: this.selectedStartDate ? moment(this.selectedStartDate[0]).format("YYYY-MM-DD") : "",
					endDate: this.selectedStartDate ? moment(this.selectedStartDate[1]).format("YYYY-MM-DD") : ""
				}
			}).then(resp => {
				if(resp.data.ec == 200){
					this.detailInfo = resp.data.data.detail
					this.detailCount = resp.data.data.total
				}
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingDetailInfo = false
		},
		async detailInfoProduct(page = 1){
			this.loadingDetailInfoProduct = true
			await api({
				method: "get",
				url: config.baseApi + "detail-info-product?page="+page+"&query="+this.searchProduct+"&query_by="+this.search_type_product,
				params: {
					// page,
					// query: this.searchProduct,
					// query_by: this.search_type_product,
					filter: "all",
					// startDate: moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
					// endDate: moment(this.selectedStartDate[1]).format("YYYY-MM-DD")
				}
			}).then(resp => {
				// console.log("res data count product",resp)
				if(resp.data.ec == 200){
					this.detailProduct = resp.data.data.data
					this.detailCountProduct = resp.data.data.total
					// console.log("detail product",this.detailProduct)

					this.detailProduct.forEach(element => {
						// console.log("element",element.numberService.product)
						// element.numberService.product.forEach(elementPrefix => {
						// 	console.log("element.prefix",elementPrefix.allowedPrefix)
						this.prefixData = element.numberService.number ? element.numberService.product.map(v=>v.allowedPrefix.toString()) : "-"
						// console.log("this.prefixData",this.prefixData)
						// });
					});
					// resp.data.data.forEach(element => {
					// 	console.log("element",element)
					// 	element.forEach(ele => {
					// 		this.detailProductVar.businessId = ele.bussinessId
					// 	})
					// 	// console.log("number service",this.detailProduct)
					// });
					// console.log("product count",this.detailCountProduct)
				}
			}).catch(err => {
				console.log("failed", err)
			})
			this.loadingDetailInfoProduct = false
		},
		async getMaskingName(search){
            return new Promise(async (resolve, reject) => {
                await api({
                    url: config.baseApi+'bussiness/get-fb-identity',
                    method: 'GET',
                    params: {
                        page: null,
                        search: search
                    }
                }).then(({ data }) => {
                    // console.log("Masking name",data.data.data);
					let dataTemp =
						data &&
						data.data &&
						data.data.consumen
							? data.data.consumen
							: [];
                    let maping = dataTemp.length > 0 ? dataTemp.map(el => { 
                        let val = {...el}
                        val.value = el.maskingName
                        return val
                    }):[]
                    let links = maping.length > 0 ? _.uniqBy(maping, 'value'): maping;
                    resolve(links)
                }).catch(error => {
                    console.log(error);
                    resolve([])
                })
			});
        },
		async loadConsumen(page = 1, customer_type = 1){
			this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'consumen',
				method:'GET',
				params: {
					page,
					customer_type: this.filter.btnStatus,
					query: this.searchCustomer,
					query_by: this.search_type
				}
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					let consumen = response.data.data.consumen
					// console.log("dp_user",this.dp_user)
					// let dp_user = []
					consumen = _.orderBy(consumen, function(o) { return new moment(o.created_at); }, ['desc']);

					if(this.filter.btnStatus){
						this.consumen = consumen
						this.total = response.data.data.total
						// console.log(this.consumen)
					}
				}
			}).catch(error => {
				// console.log("Error",error)
			})
			this.loadingConsumen = false
		},
		async loadProduct(){
			this.loadingConsumen = true
            await api({
                url: config.baseApi + "product",
                method: 'get'
            })
            .then(res => {
				var products = res.data.data.product
				products.forEach(element => {
					this.product.push({
						productName:element.productName
					})
				});
				// if(res.data.ec != 200){
				// 	// console.log('fatal error')
				// 	this.$swal(this.$t('error'), this.$t('error_text'), "error")
				// }
				// else {
				// 	// console.log(res.data)
				// 	var product = res.data.data.product
				// 	this.product = res.data.data.product
				// 	this.total = res.data.data.total
				// }
            })
            .catch(err => {

            })
            this.loadingConsumen = false
		},

		async addProductUser(){
			// console.log('Add product user')
			let custId = this.$route.params.consumen
			// console.log('id',custId)
			await api({
				method:'post',
				url:config.baseApi+'consumen/'+custId/+'/addProductUser',
				data:{
					"product": this.selectProductAssigned,
					"phone_number":''
				}
			}).then(res => {
				// console.log('response add product user',res.data)
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
			}).catch(err => {
				// console.log('error',err.message)
			})
		},

		async paginateConsumen(page){
			this.currentPage = page
			this.buildQueryParam("page", page)
			await this.loadConsumen(this.currentPage)
		},
		async paginateService(page){
			this.currentPage = page
			this.buildQueryParam("page", page)
			await this.listAllServices(this.currentPage)
		},
		async paginateDetailInfo(page){
			this.currentPage = page
			this.buildQueryParam("page", page)
			await this.detailInfoData(this.currentPage)
		},
		async paginateProduct(page){
			this.currentPage = page
			this.buildQueryParam("page", page)
			await this.detailInfoProduct(this.currentPage)
		},
		async detailConsumen(param){
			this.$router.push('consumen/' + param)
		}
	},
	async mounted(){
		if(this.$route.query.page){
			this.currentPage = parseInt(this.$route.query.page)
			// console.log("current page",this.currentPage);
		}
		await this.loadDetailInfo()
		await this.loadConsumen(this.currentPage)
		this.detailInfoData()
		this.detailInfoProduct()
		this.getMaskingName()
		this.loadProduct()
		this.loadAllService()
	},
	// watch: {
    //     dateRange: function() {
    //         this.selectedStartDate = this.dateRange
    //     }
    // }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';
@import '../assets/scss/tables';
@import '../assets/scss/v2-table';
@import '../assets/scss/vue-good-table';

.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
.search-customer {
  width: 100%;
}
</style>
